module.exports = __webpack_public_path__ + "static/1285124183.e7322b8c.jpg";